<template>
  <div
    class="bell-btn"
    v-if="route.name && !hideBellRoutes.includes(route.name.toString())"
  >
    <BellButton />
  </div>
  <router-view></router-view>
</template>

<script setup>
import { useRoute } from "vue-router";
import BellButton from "@/components/BellButton.vue";

const route = useRoute();
const hideBellRoutes = [
  "Login",
  "ObjectsView",
  "UsersView",
  "ReportsView",
  "CarriersView",
  "NotificationView",
  "ConfigurationView",
];
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
}

@font-face {
  font-family: OpenSansRegular;
  src: url("./assets/fonts/OpenSans-Regular.ttf");
}
@font-face {
  font-family: OpenSansSemiBold;
  src: url("./assets/fonts/OpenSans-SemiBold.ttf");
}

@font-face {
  font-family: OpenSansBold;
  src: url("./assets/fonts/OpenSans-Bold.ttf");
}

@font-face {
  font-family: Acrom;
  src: url("./assets/fonts/Acrom-ExtraBold.ttf");
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 100px;
}

::-webkit-scrollbar-thumb {
  background-color: #005291;
  border-radius: 100px;
}

.pointers-inactive {
  pointer-events: none;
}
.bell-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 2;
}
</style>

<!--table styles-->
<style>
.vue3-easy-data-table {
  height: 100%;
}

.vue3-easy-data-table__main {
  max-height: 100%;
  height: 100%;
}

.vue3-easy-data-table__main .header-text {
  font-family: OpenSansBold, sans-serif;
}

.vue3-easy-data-table__header tr th {
  border-top: 1px solid rgba(218, 218, 218, 0.5) !important;
  border-bottom: 1px solid rgba(218, 218, 218, 0.5) !important;
}

.vue3-easy-data-table__message {
  font-size: 14px !important;
  color: #4d5460 !important;
}

.vue3-easy-data-table__footer {
  width: unset !important;
  margin: 0 20px 0 20px !important;
  border-radius: 10px;
}

.pagination__rows-per-page {
  flex-shrink: 0;
  font-size: 0;
}

.pagination__rows-per-page .select-items.show {
  top: unset !important;
  bottom: 32px !important;
}

.pagination__rows-per-page .select-items {
  border-radius: 10px;
}

.pagination__rows-per-page .select-items li:first-child {
  border-radius: 10px 10px 0 0;
}

.pagination__rows-per-page .select-items li:hover {
  background-color: #005291 !important;
  color: #ffffff !important;
}

.pagination__rows-per-page .select-items li:last-child {
  border-radius: 0 0 10px 10px;
}

.pagination__items-index {
  width: 100%;
  margin: 0 20px 0 1px !important;
}

.easy-data-table__rows-selector {
  font-size: 14px;
  position: relative;
  margin-left: 100px !important;
}

.easy-data-table__rows-selector:before {
  content: "Кол-во строк:";
  font-size: 14px;
  position: absolute;
  top: 4px;
  width: 100px;
  right: 70px;
  pointer-events: none;
}

.easy-data-table__rows-selector .triangle {
  transform: rotate(180deg);
}

.previous-page__click-button,
.next-page__click-button {
  font-size: 0;
  position: relative;
}

.previous-page__click-button::before {
  content: "Страница:";
  font-size: 14px;
  display: flex;
  position: absolute;
  top: -5px;
  right: 25px;
  pointer-events: none;
}

.previous-page__click-button .arrow,
.next-page__click-button .arrow {
  width: 12px !important;
  height: 12px !important;
  border-top: 2px solid #4d5460 !important;
  border-left: 2px solid #4d5460 !important;
}

.previous-page__click-button.first-page .arrow,
.next-page__click-button.last-page .arrow {
  width: 12px !important;
  height: 12px !important;
  border-top: 2px solid #e0e0e0 !important;
  border-left: 2px solid #e0e0e0 !important;
}

.buttons-pagination .item {
  margin: 0 2px;
  border-radius: 6px !important;
  border: 1px solid #005291 !important;
}

.buttons-pagination .item.omission {
  border: 1px solid transparent !important;
}

.easy-data-table__rows-selector .rows-input__wrapper {
  height: 30px !important;
  border-bottom: 0 !important;
  border-radius: 10px !important;
  padding: 0 8px !important;
  background: white;
}

.vue3-easy-data-table__body tr {
  position: relative !important;
}

.vue3-easy-data-table__body tr td {
  z-index: 5;
}

.vue3-easy-data-table__body tr td:nth-child(2) {
  position: static !important;
}

.carriers-table .vue3-easy-data-table__body tr td:nth-child(1) {
  position: static !important;
}

.carriers-table .vue3-easy-data-table__body tr td:nth-child(2) {
  position: relative !important;
}

.objects-table .vue3-easy-data-table__body tr td:nth-child(1) {
  position: relative !important;
}

.objects-table .vue3-easy-data-table__body tr td:nth-child(2) {
  position: static !important;
}

.admin-table.objects-table .vue3-easy-data-table__body tr td:nth-child(2) {
  position: relative !important;
}

.admin-table.objects-table .vue3-easy-data-table__body tr td:nth-child(3) {
  position: static !important;
}

.vue3-easy-data-table__header {
  z-index: 7;
}

.notifications-table .vue3-easy-data-table__footer {
  display: none !important;
}

.customize-table {
  --easy-table-border: none;
  --easy-table-row-border: 1px solid transparent;

  --easy-table-header-font-size: 14px;
  --easy-table-header-height: 50px;
  --easy-table-header-font-color: #4d5460;
  --easy-table-header-background-color: #fff;

  --easy-table-header-item-padding: 10px 15px;

  --easy-table-body-even-row-font-color: #fff;
  --easy-table-body-even-row-background-color: #fff;

  --easy-table-body-row-font-color: #4d5460;
  --easy-table-body-row-background-color: transparent;
  --easy-table-body-row-height: 40px;
  --easy-table-body-row-font-size: 14px;

  --easy-table-body-row-hover-font-color: #4d5460;
  --easy-table-body-row-hover-background-color: #dde5ed;

  --easy-table-body-item-padding: 10px 15px;

  --easy-table-footer-background-color: #dde5ed;
  --easy-table-footer-font-color: #4d5460;
  --easy-table-footer-font-size: 14px;
  --easy-table-footer-padding: 0px 10px;
  --easy-table-footer-height: 43px;

  --easy-table-rows-per-page-selector-width: 70px;
  --easy-table-rows-per-page-selector-option-padding: 10px;
  --easy-table-rows-per-page-selector-z-index: 8;

  --easy-table-scrollbar-track-color: transparent;
  --easy-table-scrollbar-color: transparent;
  --easy-table-scrollbar-thumb-color: #005291;
  --easy-table-scrollbar-corner-color: transparent;

  /*--easy-table-loading-mask-background-color: #2d3a4f;*/
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  .customize-table {
    --easy-table-body-row-hover-background-color: transparent;
  }
}

/* < 768 */
@media screen and (max-width: 767px) {
  .vue3-easy-data-table__footer {
    margin: 0 15px 0 15px !important;
  }

  .previous-page__click-button::before {
    display: none;
  }

  .vue3-easy-data-table__header th {
    padding: 5px 10px !important;
  }

  .vue3-easy-data-table__body td {
    padding: 5px 10px !important;
  }
}

/* < 620 */
@media screen and (max-width: 619px) {
  .vue3-easy-data-table__footer {
    margin: 0 !important;
    border-radius: 0;
  }

  .easy-data-table__rows-selector {
    margin-left: 0 !important;
  }

  .easy-data-table__rows-selector:before {
    display: none;
  }
}

/* < 520 */
@media screen and (max-width: 519px) {
  .pagination__items-index {
    display: none;
  }

  .pagination__rows-per-page {
    margin-right: auto !important;
  }
}
</style>

<!--multiselect styles-->
<style>
.component-block .multiselect {
  background: transparent;
  border-radius: 10px !important;
  border: 1px solid #005291;
}

.component-block .multiselect-wrapper {
  padding-top: 6px;
}

.component-block .multiselect.is-active {
  box-shadow: none;
  border: 1px solid #005291;
  border-radius: 10px;
}

.component-block .multiselect-tags-search {
  background: transparent;
  color: #4d5460;
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 14px;
}

.component-block .multiselect-placeholder {
  color: #4d5460;
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 14px;
}

.component-block .multiselect-tag {
  background: #005291;
  border-radius: 10px;
  color: #fff;
  padding: 5px 0 5px 8px;
}

.component-block .multiselect-tag .multiselect-tag-wrapper {
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 14px;
}

.component-block .multiselect-tag-remove-icon {
  width: 17px;
  height: 17px;
}

.component-block .pointers-inactive .multiselect-tag-remove-icon {
  opacity: 0;
}

.component-block .multiselect-clear {
  padding: 0;
  margin-right: 10px;
}

.component-block .multiselect-clear-icon {
  width: 17px;
  height: 17px;
  background: #4d5460;
}

.component-block .multiselect-clear:hover .multiselect-clear-icon {
  background: #4d5460;
}

.component-block .multiselect-caret {
  width: 12px;
  height: 12px;
  border-top: 2px solid #4d5460 !important;
  border-left: 2px solid #4d5460 !important;
  border-right: 0;
  transform: rotate(-135deg);
  transition: all 0.2s;
  -webkit-mask-image: none;
  mask-image: none;
  background: transparent;
  top: -3px;
}

.component-block .multiselect-caret.is-open {
  transform: rotate(45deg);
  top: 2px;
}

.component-block .pointers-inactive .multiselect-caret {
  display: none;
}

.component-block .pointers-inactive .multiselect-clear {
  display: none;
}

.component-block .multiselect-dropdown {
  border-radius: 10px;
  background: #dde5ed;
  border: 1px solid #005291;
  transform: translateY(102%);
  overflow: auto;
}

.component-block .modal .multiselect-dropdown {
  background: #ffffff;
}

.component-block .multiselect-option,
.component-block .multiselect-option.is-pointed {
  color: #4d5460;
  background: transparent;
}

.component-block .multiselect-option span,
.component-block .multiselect-option.is-pointed span {
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 14px;
  font-weight: normal;
}

.component-block .multiselect-option:hover,
.component-block .multiselect-option.is-selected,
.component-block .multiselect-option.is-selected.is-pointed {
  color: #ffffff;
  background: #005291;
}

.component-block .multiselect-label-wrapper {
  position: relative;
  margin-bottom: 17px;
}

.component-block .singleselect-label-wrapper {
  position: relative;
  margin-bottom: 17px;
}

.component-block .singleselect-label-wrapper .multiselect-clear {
  display: none;
}

.component-block .filter-menu .multiselect-clear {
  display: none;
}

.component-block .multiselect-single-label span {
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 14px;
  font-weight: normal;
  color: #4d5460;
}

.component-block .edit-multiselect-label {
  position: absolute;
  top: -11px;
  left: 7px;
  font-size: 12px;
  padding: 0 3px;
  color: #005291;
  background: #dde5ed;
  z-index: 1;
}

.component-block .modal .edit-multiselect-label {
  background: #ffffff;
}

.component-block .multiselect-search {
  border-radius: 10px;
  background: transparent;
  padding-left: 10px;
}

.component-block .multiselect-single-label {
  padding-left: 10px;
}

@media screen and (max-width: 1439px) {
}
</style>

<!--edit/create input, dropdown-->
<style>
.component-block .edit-input {
  width: 100%;
  margin-bottom: 17px;
  position: relative;
}

.component-block .edit-input-label {
  position: absolute;
  top: -11px;
  left: 7px;
  font-size: 12px;
  padding: 0 3px;
  color: #005291;
  background: #dde5ed;
  transition: all 0.4s;
}

.component-block .modal .edit-input-label {
  background: #ffffff;
}

.component-block .edit-input input {
  width: 100%;
  height: 38px;
  padding: 10px;
  border: 1px solid #005291;
  border-radius: 10px;
  outline: none;
  background: transparent;
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 14px;
  color: #4d5460;
  transition: all 0.4s;
}

.component-block .edit-input input::placeholder {
  font-size: 14px;
}

.component-block .edit-input.error-input input {
  border: 1px solid red;
}

.component-block .edit-input.error-input .edit-input-label {
  color: red;
}

.component-block .edit-error {
  margin-left: 10px;
  font-size: 11px;
  color: red;
}

.component-block .edit-dropdown {
  width: 100%;
  margin-bottom: 17px;
  position: relative;
}

.component-block .edit-dropdown button {
  width: 100%;
  height: 38px;
  padding: 10px;
  border: 1px solid #005291;
  border-radius: 10px;
  position: relative;
  text-align: left;
  background: transparent;
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 14px;
  color: #4d5460;
  display: flex;
  align-items: center;
}

.component-block .edit-dropdown button:active {
  border: 1px solid #005291;
  color: #4d5460;
}

.component-block .edit-dropdown button:after {
  content: "";
  position: absolute;
  right: 15px;
  top: 12px;
  width: 12px;
  height: 12px;
  border-top: 2px solid #4d5460 !important;
  border-left: 2px solid #4d5460 !important;
  border-right: 0;
  transform: rotate(-135deg);
  transition: all 0.2s;
}

.component-block .edit-dropdown button.show:after {
  transform: rotate(45deg);
  top: 17px;
}

.component-block .edit-dropdown .dropdown-menu {
  width: 100%;
  background: #dde5ed;
  border: 1px solid #005291;
  border-radius: 10px;
  font-size: 14px;
}

.component-block .modal .edit-dropdown .dropdown-menu {
  background: #ffffff;
}

.component-block .edit-dropdown .dropdown-menu .dropdown-item {
  padding: 6px 10px;
  color: #4d5460;
  font-family: OpenSansSemiBold, sans-serif;
}

.component-block .edit-dropdown .dropdown-menu .dropdown-item:hover,
.edit-dropdown .dropdown-menu .dropdown-item:active {
  background: #005291;
  color: #ffffff;
}

.component-block .edit-dropdown-label {
  position: absolute;
  top: -11px;
  left: 7px;
  font-size: 12px;
  padding: 0 3px;
  color: #005291;
  background: #dde5ed;
  z-index: 1;
}

.component-block .modal .edit-dropdown-label {
  background: #ffffff;
}

@media screen and (max-width: 1439px) {
}
</style>

<!--datepicker styles-->
<style>
.component-block .dp__input_icon_pad,
.component-block .dp__input_icon_pad:hover {
  padding-inline-start: 12px;
  padding: 6px 12px;
  background: transparent;
  outline: none;
  border: 1px solid #005291;
  font-family: OpenSansSemiBold, sans-serif;
  font-size: 14px;
  color: #4d5460;
  border-radius: 10px;
  max-width: 140px;
}

@media screen and (max-width: 474px) {
  .component-block .dp__input_icon_pad,
  .component-block .dp__input_icon_pad:hover {
    max-width: 100%;
  }
}

.component-block .dp__input_icon {
  display: none;
}

.component-block .dp__clear_icon {
  color: #4d5460;
  padding: 6px 8px;
}

body .dp__theme_light {
  --dp-background-color: #fff;
  --dp-text-color: #212121;
  --dp-hover-color: #f3f3f3;
  --dp-hover-text-color: #212121;
  --dp-hover-icon-color: #959595;
  --dp-primary-color: #005291;
  --dp-primary-disabled-color: #6bacea;
  --dp-primary-text-color: #f8f5f5;
  --dp-secondary-color: #c0c4cc;
  --dp-border-color: #ddd;
  --dp-menu-border-color: #ddd;
  --dp-border-color-hover: #aaaeb7;
  --dp-disabled-color: #f6f6f6;
  --dp-scroll-bar-background: #f3f3f3;
  --dp-scroll-bar-color: #959595;
  --dp-success-color: #76d275;
  --dp-success-color-disabled: #a3d9b1;
  --dp-icon-color: #959595;
  --dp-danger-color: #ff6f60;
  --dp-marker-color: #ff6f60;
  --dp-tooltip-color: #fafafa;
  --dp-disabled-color-text: #8e8e8e;
  --dp-highlight-color: rgb(25 118 210 / 10%);
  --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
  --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
  --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);
}
</style>

<!--swal styles-->
<style>
div:where(.swal2-container) button:where(.swal2-styled).swal2-confirm,
div:where(.swal2-container) button:where(.swal2-styled).swal2-cancel,
div:where(.swal2-container) div:where(.swal2-popup) {
  border-radius: 10px !important;
}
</style>

<!--popper styles-->
<style>
.popup-popper {
  border-radius: 8px;
  padding: 5px 10px;
  box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
  color: #4d5460;
  background: white;
  font-size: 12px;
}

.popup-popper.monitoring {
  color: white;
  background: transparent;
}
</style>
